'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgHighlight = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.3 15.3c-.56.56-1.24.96-2 1.17v-1.14a.683.683 0 0 0-.67-.67h-1.3c-.37.01-.66.3-.67.67v1.13a4.677 4.677 0 0 1-3.13-3.13h1.14c.37-.01.66-.3.67-.67v-1.33a.683.683 0 0 0-.67-.67H7.53c.45-1.5 1.63-2.68 3.13-3.13v1.14c.01.37.3.66.67.67h1.33c.37-.01.66-.3.67-.67V7.53c1.5.45 2.68 1.63 3.13 3.13h-1.13c-.37.01-.66.3-.67.67v1.33c.01.37.3.66.67.67h1.13c-.21.74-.61 1.42-1.16 1.97zm4.7-4a.683.683 0 0 0-.67-.67h-1.49c-.51-2.24-2.27-4-4.51-4.51V4.66a.688.688 0 0 0-.66-.67h-1.34a.69.69 0 0 0-.67.67v1.49c-2.24.51-4 2.27-4.51 4.51H4.67c-.37.01-.66.31-.67.68v1.33c.01.37.3.66.67.67h1.49c.51 2.24 2.27 4 4.51 4.51v1.49c.01.37.3.66.67.67h1.33c.37-.01.66-.3.67-.67v-1.5c2.24-.51 4-2.27 4.51-4.51h1.49c.36-.01.65-.3.66-.66V11.3z",
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke"
})));

exports["default"] = SvgHighlight;
